import { Vue, Component, Prop } from 'vue-property-decorator';

/**
 * Empty state
 */
@Component({
    name: 'SaveState',
})
export default class Save extends Vue {
    /**
     * State
     */
    @Prop({ type: String, default: 'loading' }) readonly state!: string;

    /**
     * Loading header text
     */
    @Prop({ type: String, default: 'l_loading_please_wait' }) readonly loadingHeaderText!: string;

    /**
     * Error header text
     */
    @Prop({ type: String, default: 'l_oh_no' }) readonly errorHeaderText!: string;

    /**
     * Validation Error header text
     */
    @Prop({ type: String, default: 'l_oh_no' }) readonly validationHeaderText!: string;

    /**
     * Success header text
     */
    @Prop({ type: String, default: 'l_all_good' }) readonly successHeaderText!: string;

    /**
     * Loading text
     */
    @Prop({ type: String, default: 'l_save_loading' }) readonly loadingText!: string;

    /**
     * Error text
     */
    @Prop({ type: String, default: 'l_save_error' }) readonly errorText!: string;

    /**
     * Validation error text
     */
    @Prop({ type: String, default: 'l_save_validation_error' }) readonly validationText!: string;

    /**
     * Success header text
     */
    @Prop({ type: String, default: 'l_save_success' }) readonly successText!: string;

    /**
     * Grab the right picture
     */
    get headerText() {
        switch (this.state) {
            default:
            case 'loading':
                return this.$t(this.loadingHeaderText);
            case 'error':
                return this.$t(this.errorHeaderText);
            case 'validation-error':
                return this.$t(this.validationHeaderText);
            case 'success':
                return this.$t(this.successHeaderText);
        }
    }

    /**
     * Grab the right text
     */
    get text() {
        switch (this.state) {
            default:
            case 'loading':
                return this.$t(this.loadingText);
            case 'error':
                return this.$t(this.errorText);
            case 'validation-error':
                return this.$t(this.validationText);
            case 'success':
                return this.$t(this.successText);
        }
    }
}
